import React from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import isEmpty from "lodash.isempty";

const PrivateRoute = ({
   component: Component,
   user,
   isLoadingUser,
   permissions,
   requiredPermission,
   ...rest
}) => {
   const isLoggedIn = isLoadingUser ? true : !isEmpty(user);
   const isAccessAllowed = permissions ? permissions[requiredPermission] : true;
   
   return (
      <Route
         {...rest}
         render={(props) => {
            if (props.location.pathname === "/access-denied" && isAccessAllowed) {
               return <Redirect to={props.location.state?.from || "/"} />;
            }

            if (props.location.pathname === "/access-denied" && !isAccessAllowed) {
               return <Component {...props} />;
            }

            if (!isLoggedIn) {
               return (
                  <Redirect
                     to={{
                        pathname: "/login",
                        state: { from: props.location }
                     }}
                  />
               );
            }

            if (!isAccessAllowed) {
               return (
                  <Redirect
                     to={{
                        pathname: "/access-denied",
                        state: { from: props.location }
                     }}
                  />
               );
            }

            return <Component {...props} />;
         }}
      />
   );
};

export default connect(
   (state) => ({
      user: state.oidc.user,
      isLoadingUser: state.oidc.isLoadingUser,
      permissions: state.session.permissions
   }),
   {}
)(PrivateRoute);
